import { useApiWithAuth } from "@/modules/api";
import { RntrcPrecoServicoPayload } from "./rntrcTypes";

const useRntrcPrecoService = () => {
  const { data, loading, get, post, put, del } = useApiWithAuth();

  /** Preços vigentes do cliente logado (root pode informar o cliente). */
  const precosVigentes = (idCliente?: number | null): Promise<void> => {
    return get("/rntrc/preco", { idCliente });
  };

  /** Root: todas as vigências; sem cliente = tabela padrão (global). */
  const listarRoot = (idCliente?: number | null): Promise<void> => {
    return get("/root/rntrc/preco", { idCliente });
  };

  const criar = (entity: RntrcPrecoServicoPayload): Promise<void> => {
    return post("/root/rntrc/preco", entity);
  };

  const atualizar = (
    idRntrcPrecoServico: number,
    entity: RntrcPrecoServicoPayload
  ): Promise<void> => {
    return put(`/root/rntrc/preco/${idRntrcPrecoServico}`, entity);
  };

  const remover = (idRntrcPrecoServico: number): Promise<void> => {
    return del(`/root/rntrc/preco/${idRntrcPrecoServico}`);
  };

  return {
    data,
    loading,
    precosVigentes,
    listarRoot,
    criar,
    atualizar,
    remover
  };
};

export { useRntrcPrecoService };
